import {ExportIcon} from "../../AppIcons";
import React, {useEffect, useRef, useState} from "react";
import $ from "jquery";
import Constants from "../../Constants";

export default function ReviewersDownloadPopup(props) {

    const toggleButtonRef = useRef(null);
    const popupRef = useRef(null);
    const [displayFilter, setDisplayFilter] = useState(false);


    useEffect(() => {
        if (displayFilter) {
            document.addEventListener("keydown", handleEscapeKey);
            document.addEventListener("click", handleClickOutside);
        } else {
            document.removeEventListener("keydown", handleEscapeKey);
            document.removeEventListener("click", handleClickOutside);
        }

        // Cleanup the event listeners
        return () => {
            document.removeEventListener("keydown", handleEscapeKey);
            document.removeEventListener("click", handleClickOutside);
        };
    }, [displayFilter]);


    const handleEscapeKey = (event) => {
        if (event.key === Constants.ESCAPE) {
            setDisplayFilter(false);
            toggleButtonRef.current?.focus();
        }
    }

    const handleClickOutside = (event) => {
        if (popupRef.current &&
            !popupRef.current.contains(event.target) &&
            !toggleButtonRef.current.contains(event.target)) {
            setDisplayFilter(false);
        }
    }


    const filterToggle = (e) => {
        // close other filters:
        let buttons = $(".filterToggle")
        let $target = $(e.target).closest(".filterToggle")
        for (let i = 0; i < buttons.length; i++) {
            let button = buttons[i];
            if (!$target.is(button)) {
                $(button).closest(".filter").find(".hideButton").click();
            }
        }
        setDisplayFilter(v => !v);
    }

    return <>
        <div className="filter-widget">
            <div className="campaign_details-task campaign-form task-page-form pt-0">
                <div className="btn-wrap">                                                    
                    <div className="filter mr-0" id="filter">                        
                        <button ref={toggleButtonRef} id="filterToggle"
                                className="filterToggle"
                                title="Download"
                                onClick={filterToggle}>
                            {ExportIcon}
                        </button>
                        <button className="hide hideButton" onClick={e => setDisplayFilter(false)}></button>
                        <div id="filterBtn" ref={popupRef}
                             className="filter-content opaque flex local-filter"
                             style={{
                                 display: displayFilter ? "block" : "none",
                                 width: "auto",
                                 minWidth: "auto",
                                 padding: "10px"
                             }}>
                            {props.children}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>
}